<ng-container *ngIf="tags.includes('Primary') as hasPrimaryTag; else noPrimaryTags">
  <glxy-badge [color]="'blue'">{{ tags[0] }}</glxy-badge>
  <ng-container *ngIf="tags.length > 1">
    <glxy-badge [color]="'grey'">{{ tags[1] }}</glxy-badge>
  </ng-container>
</ng-container>

<ng-container *ngIf="!hasPrimaryTag">
  <ng-container *ngTemplateOutlet="noPrimaryTagsAlt"></ng-container>
</ng-container>
<ng-container *ngIf="hasPrimaryTag">
  <ng-container *ngTemplateOutlet="hasPrimaryTag"></ng-container>
</ng-container>

<ng-template #noPrimaryTags>
  <ng-container *ngIf="tags.length >= 1">
    <glxy-badge [color]="'grey'">{{ tags[0] }}</glxy-badge>
  </ng-container>
  <ng-container *ngIf="tags.length >= 2">
    <glxy-badge [color]="'grey'">{{ tags[1] }}</glxy-badge>
  </ng-container>
</ng-template>

<ng-template #hasPrimaryTag>
  <glxy-badge *ngIf="tags.length >= 3" [glxyTooltip]="tags.slice(2).join(', ')">+{{ tags.length - 2 }}</glxy-badge>
</ng-template>

<ng-template #noPrimaryTagsAlt>
  <glxy-badge *ngIf="tags.length >= 3" [glxyTooltip]="tags.slice(2).join(', ')">+{{ tags.length - 2 }}</glxy-badge>
</ng-template>
